import React from 'react';
import styled from "styled-components";
import { Atom } from 'AppReact';


const template = styled.b`display: block; margin: 10px 0;`

export default Atom({ type: 'label', dataType: 'string', template})
